/* =========================================================
   ParfumShop38 — comportements des sections personnalisées
   FAQ accordéon · compteurs animés · quiz « trouvez votre parfum »
   Tout est en délégation d'évènements : rien ne casse si une
   section est ajoutée ou rechargée depuis l'éditeur de thème.
   ========================================================= */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- FAQ ---------------- */

  function closeFaq(item) {
    var panel = item.querySelector('.ps-faq__a');
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () {
      panel.style.height = '0px';
    });
    item.classList.remove('is-open');
    var btn = item.querySelector('.ps-faq__q');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function openFaq(item) {
    var panel = item.querySelector('.ps-faq__a');
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    item.classList.add('is-open');
    var btn = item.querySelector('.ps-faq__q');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      if (item.classList.contains('is-open')) panel.style.height = 'auto';
    }, 450);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.ps-faq__q');
    if (!btn) return;
    var item = btn.closest('.ps-faq__item');
    if (!item) return;
    var faq = item.closest('.ps-faq');
    var single = faq && faq.getAttribute('data-single') === 'true';

    if (item.classList.contains('is-open')) {
      closeFaq(item);
      return;
    }
    if (single && faq) {
      Array.prototype.forEach.call(faq.querySelectorAll('.ps-faq__item.is-open'), closeFaq);
    }
    openFaq(item);
  });

  /* ---------------- Compteurs ---------------- */

  var counterObserver = null;

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduced) {
      el.textContent = prefix + target + suffix;
      return;
    }
    var duration = 1400;
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var value = Math.round(target * eased);
      el.textContent = prefix + value + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initCounters(scope) {
    var els = (scope || document).querySelectorAll('[data-count-to]:not([data-counted])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.setAttribute('data-counted', '');
        animateCounter(el);
      });
      return;
    }
    if (!counterObserver) {
      counterObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-counted', '');
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.4 }
      );
    }
    Array.prototype.forEach.call(els, function (el) {
      counterObserver.observe(el);
    });
  }

  /* ---------------- Quiz ---------------- */

  function initQuiz(quiz) {
    if (!quiz || quiz.getAttribute('data-ready') === 'true') return;
    quiz.setAttribute('data-ready', 'true');

    var steps = Array.prototype.slice.call(quiz.querySelectorAll('.ps-quiz__step'));
    var bar = quiz.querySelector('.ps-quiz__bar span');
    var back = quiz.querySelector('.ps-quiz__back');
    var results = Array.prototype.slice.call(quiz.querySelectorAll('.ps-quiz__result'));
    var answers = [];
    var index = 0;

    var questionCount = steps.filter(function (s) {
      return s.getAttribute('data-role') === 'question';
    }).length;

    function show(i) {
      index = i;
      steps.forEach(function (step, n) {
        step.classList.toggle('is-active', n === i);
      });
      if (bar) {
        var pct = questionCount ? Math.min((i / questionCount) * 100, 100) : 100;
        bar.style.width = pct + '%';
      }
      if (back) back.hidden = i === 0;
    }

    function pickResult() {
      var chosen = null;
      var bestScore = -1;
      results.forEach(function (res) {
        var keysRaw = (res.getAttribute('data-keys') || '').trim();
        var keys = keysRaw
          ? keysRaw
              .split(',')
              .map(function (k) {
                return k.trim().toLowerCase();
              })
              .filter(Boolean)
          : [];
        var all = keys.every(function (k) {
          return answers.indexOf(k) !== -1;
        });
        if (!all) return;
        if (keys.length > bestScore) {
          bestScore = keys.length;
          chosen = res;
        }
      });
      results.forEach(function (res) {
        res.hidden = res !== chosen;
      });
      if (!chosen && results.length) results[results.length - 1].hidden = false;
      show(steps.length - 1);
      if (bar) bar.style.width = '100%';
      var wrapper = quiz.querySelector('.ps-quiz__results');
      if (wrapper) wrapper.classList.add('is-active');
    }

    quiz.addEventListener('click', function (event) {
      var opt = event.target.closest && event.target.closest('.ps-quiz__opt');
      if (opt && quiz.contains(opt)) {
        var value = (opt.getAttribute('data-value') || '').trim().toLowerCase();
        answers[index] = value;
        answers = answers.slice(0, index + 1);
        if (index + 1 < questionCount) {
          show(index + 1);
        } else {
          pickResult();
        }
        return;
      }
      if (event.target.closest && event.target.closest('.ps-quiz__back')) {
        if (index > 0) show(index - 1);
        return;
      }
      if (event.target.closest && event.target.closest('.ps-quiz__restart')) {
        answers = [];
        results.forEach(function (r) {
          r.hidden = true;
        });
        show(0);
      }
    });

    show(0);
  }

  function initQuizzes(scope) {
    var list = (scope || document).querySelectorAll('.ps-quiz');
    Array.prototype.forEach.call(list, initQuiz);
  }

  /* ---------------- Amorçage ---------------- */

  function boot(scope) {
    initCounters(scope);
    initQuizzes(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();
